var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAw = function SvgAw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M12 24c3.637 0 6.896-1.618 9.096-4.174H2.903A11.972 11.972 0 0 0 12 24ZM24 12c0-6.627-5.373-12-12-12S0 5.373 0 12c0 1.083.144 2.132.413 3.13h23.174c.269-.998.413-2.047.413-3.13ZM.954 16.696c.231.544.502 1.066.808 1.565h20.477c.306-.499.576-1.021.808-1.565H.954Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M5.499 7.569 3.154 6.534 5.5 5.5l1.034-2.345L7.568 5.5l2.345 1.034L7.568 7.57 6.533 9.914 5.5 7.569Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "m6.533 4.447.64 1.448 1.447.64-1.448.638-.639 1.448-.639-1.448-1.448-.639 1.448-.639.64-1.448Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgAw;